import React from "react";
import { Grid, Typography, Box, Paper, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

// --- Hardcoded Team Data (Corrected Image URLs) ---
const teamMembers = [
  {
    id: 1,
    name: "Monika Jain",
    title: "Founder and CEO",
    image: "/images/team_member/Monika Jain.png",
    description:
      "Serial entrepreneur and Top 100 Innovators Award recipient with two successful exits. My journey began in India with a Young Entrepreneur Award and has taken me across industries — from infrastructure to luxury. Today, I lead Zipang Auctions, a global platform reshaping how certified diamonds, jewelry, and watches are traded. With auctions across Tokyo, Hong Kong, New York, and Dubai, our vision is to build the world’s #1 marketplace for pre-loved luxury — powered by trust, transparency, and AI-driven innovation. Passionate about scaling bold ideas and empowering women entrepreneurs worldwide.",
    linkedinUrl: "https://www.linkedin.com/in/monika-jain-84a72428/", // Added specific LinkedIn URL
  },
  {
    id: 2,
    name: "Shobhit Suchanti",
    title: "Co-Founder & Chief Gemologist  ",
    image: "/images/team_member/Shobhit Suchanti.png",
    description:
      "Shobhit Suchanti is a GIA-qualified diamond expert and certified gemologist with over 18 years of hands-on experience in the diamond and gemstone industry. With a decade of experience in Japan’s auction scene, he has evaluated and curated thousands of exceptional stones for international auctions in Japan, Hong Kong, New York, Las Vegas, and Dubai. As a trusted curator at Zipang Auctions, Shobhit blends technical precision with a deep passion for helping buyers truly understand the value and beauty of each diamond.",
    linkedinUrl: "https://www.linkedin.com/in/shobhit-suchanti/", // Added LinkedIn URL
  },
  {
    id: 3,
    name: "Sarthak Jain",
    title: "Director ",
    image: "/images/team_member/Sarthak Jain.png",
    description:
      "A Diamond merchant with an experience of 4 years in diamond industry with leveraging his expertise to source diamonds, Sarthak manages inventory operations , excise and logistics, between Japan, USA, Belgium, Israel, Dubai, India and Hong Kong. The focus is on smooth coordination, compliance, and the efficient movement of high-value goods across borders.“I believe operational excellence builds the foundation for trust — and my goal is to ensure that Zipang’s backend and frontend runs as precisely as the diamonds we trade.” ",
    linkedinUrl: "https://www.linkedin.com/in/sarthak-jain-a7545a30b/", // Added LinkedIn URL
  },
  {
    id: 4,
    name: "Pradeep Sharma",
    title: "CTO",
    image: "/images/team_member/Pradeep Sharma.png",
    description:
      "With over 20 years of industry experience, Pradeep Sharma, tech head at Zipang Auctions, leads the technology front with strategic foresight and hands-on expertise. Known for his sharp problem-solving skills, he’s always battle-ready to tackle any tech challenge. A true backend powerhouse, he ensures every auction runs seamlessly with performance, precision, and innovation at its core.",
    linkedinUrl: "https://www.linkedin.com/in/pradeep-sharma-67304310/ ", // Added LinkedIn URL
  },
  {
    id: 5,
    name: "Kanishk Choraria",
    title: "COO",
    image: "/images/team_member/Kanishk Choraria.png",
    description:
      "Kanishk Choraria, COO at Zipang, leads strategic operations and drives sustainable business growth. With strong operational expertise and leadership, Choraria optimizes processes, expands market reach, and accelerates business momentum, enhancing customer experience and unlocking new revenue opportunities for Zipang’s continued success..",
    linkedinUrl: "https://www.linkedin.com/in/kanishkchoraria/ ", // Added LinkedIn URL
  },

  {
    id: 6,
    name: "Yuko Ogino",
    title: "Head of Japan Operations",
    image: "/images/team_member/Yuko Ogino.png",
    description:
      "I have been leading Zipang’s operations from past 8 years in Japan, making sure every process — from cataloging to client service — runs smoothly and reflects our commitment to precision. I take pride in maintaining high standards while ensuring that every client interaction (Japanese or English) feels personal and seamless.My goal is to keep Zipang known not just for its exceptional goods, but also for the professionalism and care behind every auction.",
    linkedinUrl: "https://www.linkedin.com/in/yuko-ogino-0381b6214/ ", // Added LinkedIn URL
  },
  {
    id: 7,
    name: "Paridhi Chordia",
    title: "Business Analyst",
    image: "/images/team_member/Paridhi Chordia.png",
    description:
      "Paridhi brings her analytical expertise and inquisitive mindset to Zipang Auctions, transforming data into actionable strategies. She plays a pivotal role in enhancing platform usability, refining UI/UX, and uncovering growth opportunities; contributing to Zipang’s continued success and expansion.",
    linkedinUrl: " https://www.linkedin.com/in/paridhi-chordia-279867184/ ", // Added LinkedIn URL
  },
  {
    id: 8,
    name: "Khushboo Jain",
    title: "Director",
    // CORRECTED: Invalid LinkedIn URL used as image source replaced with a placeholder
    image: "/images/team_member/Khushboo Jain.png",
    description:
      "Director at Zipang Auctions, driving growth and global expansion in the luxury resale space. With experience spanning from India to London to Japan , I focus on building strong partnerships, scaling operations, and ensuring transparency in how certified diamonds, fine jewelry, and watches reach the market At Zipang, we are building the world’s #1 marketplace for pre-loved luxury, with auctions across Tokyo, Hong Kong, New York, Dubai and world around. My role is to align strategy with execution — empowering both sellers and buyers through technology, trust, and innovation.Enthusiastic about cross-border business, leadership, and assisting women entrepreneurs.",
    linkedinUrl: "https://www.linkedin.com/in/khushboo-jain-0334051a9/ ", // Added LinkedIn URL
  },
  {
    id: 9,
    name: "Anubhav Dobhal",
    title: "Sales Manager",
    image: "/images/team_member/Anubhav Dhobhal.png",
    description:
      "As Sales Manager, I work with clients across different regions to help them discover and acquire limited and exceptional pieces through Zipang Auctions. I enjoy connecting with people, understanding their needs, helping them meet their own kind of luxury and guiding them through the buying process with transparency and care. Every successful transaction is more than a sale — it’s the start of a trusted relationship.",
    linkedinUrl: "https://www.linkedin.com/in/anubhavdobhal?trk=contact-info", // Added LinkedIn URL
  },
  {
    id: 10,
    name: "Rahul Vyas",
    title: "Fullstack Developer",
    image: "/images/team_member/Rahul Vyas.png",
    description:
      "Rahul Vyas, Full Stack Developer at Zipang Auctions, leverages his expertise in web, Android, and iOS development to deliver seamless, user-friendly solutions. Always proactive and solution-oriented, he ensures platform efficiency while supporting the company’s growth and innovation.",
    linkedinUrl: "https://www.linkedin.com/in/imrahulvyas/ ", // Added LinkedIn URL
  },
  {
    id: 11,
    name: "Rajnandni Yadav",
    title: "Frontend Developer",
    image: "/images/team_member/Rajnandini Yadav.png",
    description:
      " Rajnandni Yadav, Frontend Developer at Zipang Auctions, specializing in creating intuitive, responsive, and visually engaging user interfaces. With a strong focus on delivering seamless user experiences, she collaborates closely with the design and backend teams to implement innovative solutions that enhance platform functionality and support the company’s growth.",
    linkedinUrl: " https://www.linkedin.com/in/rajnandni-yadav-098b48272/", // Added LinkedIn URL
  },
  {
    id: 12,
    name: "Kanika Agarwal",
    title: "Quality Analyst",
    // CORRECTED: Invalid LinkedIn URL used as image source replaced with a placeholder
    image: "/images/team_member/Kanika Agarwal.png",
    description:
      "Kanika Agarwal, Quality Analyst at Zipang Auctions, is dedicated to maintaining top-notch quality and performance. With sharp analytical skills and a focus on perfection, she ensures a flawless, reliable, and user-centric platform experience.",
    linkedinUrl: " https://www.linkedin.com/in/kanika-agarwal-76998a214/ ", // Added LinkedIn URL
  },
  {
    id: 13,
    name: "Paresh Bafna",
    title: "Head of Social Media & Marketing",
    image: "/images/team_member/Paresh Bafna.png",
    description:
      "I oversee Zipang's marketing and social media strategy, telling the online story of our company. My goal is to build significant online relationships that capture Zipang's unique blend of elegance, innovation, and history. I want every encounter with Zipang to feel genuine and motivating through careful storytelling and imaginative campaigns.",
    linkedinUrl: "https://www.linkedin.com/in/pareshbafna1/ ", // Added LinkedIn URL
  },
  {
    id: 14,
    name: "Anchal Bothra",
    title: "Social Media Executive ",
    image: "/images/team_member/Anchal Bothra.png",
    description:
      "I produce and oversee content as a member of Zipang's social media team that highlights the beauty and thrill of our auctions. I like to engage our community with the beauty of fine jewelry and gemstones by fusing creativity and storytelling.My objective is to maintain Zipang's online presence interesting, reliable, and faithful to the luxury and trust that characterize our brand.",
    linkedinUrl: "https://www.linkedin.com/in/anchalbothra/", // Added LinkedIn URL
  },
];

// --- Sub-Component for a Single Profile Card ---
type TeamMember = {
  id: number;
  name: string;
  title: string;
  image: string;
  description: string;
  linkedinUrl: string; // Updated type to include linkedinUrl
};

type TeamCardProps = {
  member: TeamMember;
};

const TeamCard: React.FC<TeamCardProps> = ({ member }) => (
  <Grid
    item
    xs={12}
    md={6}
    lg={6}
    xl={4}
    sx={{ display: "flex", justifyContent: "center", alignItems: "stretch" }}
  >
    <Paper
      elevation={2}
      sx={(theme) => ({
        height: "100%",
        p: 0,
        borderRadius: 2,
        transition: "0.3s",
        overflow: "hidden",
        "&:hover": { boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)" },
        width: "100%",
        [theme.breakpoints.up("xl")]: { maxWidth: 514 },
      })}
    >
      <Grid
        container
        spacing={0}
        wrap="wrap"
        sx={(theme) => ({
          height: "100%",
          width: "100%",
          alignItems: "stretch",
          [theme.breakpoints.up("lg")]: {
            flexWrap: "nowrap", // only lock layout for really wide screens
          },
        })}
      >
        {/* 🖼️ Image Section */}
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
            flexShrink: 0,
            flexGrow: 0,
          }}
        >
          <Box
            component="img"
            src={member.image}
            alt={member.name}
            sx={(theme) => ({
              width: "100%",
              height: "auto",
              maxWidth: { xs: 140, sm: 180, md: 200, lg: 220 }, // ✅ Responsive max widths
              maxHeight: { xs: 140, sm: 180, md: 200, lg: 220 }, // ✅ Prevents oversized image
              borderRadius: 2,
              objectFit: "contain", // ✅ ensures no cropping
              aspectRatio: "1 / 1", // keeps square shape on all screens
              [theme.breakpoints.down("sm")]: {
                width: 120,
                height: 120,
                aspectRatio: "auto",
              },
            })}
          />
        </Grid>

        {/* 📄 Text Section */}
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            textAlign: { xs: "center", md: "left" },
            p: 2,
          }}
        >
          {/* Name + LinkedIn */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
              mb: 0.5,
              flexWrap: "wrap",
              gap: 0.5,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{
                lineHeight: 1.2,
                fontFamily: "sans-serif",
              }}
            >
              {member.name}
            </Typography>

            <IconButton
              size="small"
              sx={{
                color: "#0A66C2",
                p: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  color: "#ffffff",
                  bgcolor: "#0A66C2",
                  transform: "scale(1.1)",
                },
              }}
              aria-label="LinkedIn profile"
              onClick={() =>
                member.linkedinUrl && window.open(member.linkedinUrl, "_blank")
              }
            >
              <Box
                component="svg"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width={20}
                height={20}
                fill="currentColor"
                role="img"
              >
                <title>LinkedIn profile</title>
                <path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M8.34 18.5V9H6V18.5H8.34M7.17 7.79A1.36 1.36 0 1 0 7.17 5.07A1.36 1.36 0 0 0 7.17 7.79M19 18.5V12.63C19 10.22 17.92 9.07 15.97 9.07C14.63 9.07 13.68 9.79 13.29 10.54H13.25V9H10.96V18.5H13.34V12.92C13.34 11.69 13.95 10.84 15.03 10.84C16.06 10.84 16.61 11.61 16.61 12.92V18.5H19Z" />
              </Box>
            </IconButton>
          </Box>

          {/* Title */}
          <Typography
            variant="subtitle1"
            sx={{
              color: "#D92B3C",
              fontWeight: 600,
              mb: 1,
              fontSize: "0.95rem",
              fontFamily: "sans-serif",
            }}
          >
            {member.title}
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            color="text.primary"
            sx={(theme) => ({
              fontSize: "0.8rem",
              fontFamily: "sans-serif",
              [theme.breakpoints.up("md")]: {
                maxHeight: 165,
                overflowY: "auto",
                pr: 1,
              },
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(0,0,0,0.2)",
                borderRadius: "4px",
              },
            })}
          >
            {member.description}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  </Grid>
);

// --- Main Component ---
const OurTeamProfileGrid: React.FC<any> = () => {
  // Mocking useTranslation for local runnable code
  const t = (key: string) => {
    switch (key) {
      case "common:zipangLanding:ourTeam:ourTeamheading":
        return "Our Team";
      case "common:zipangLanding:ourTeam:ourteamSubHeading":
        return "Empowering Bidding Brilliance Unveiled At Zipang";
      default:
        return key.split(":").pop();
    }
  };
  // let { t } = useTranslation(); // Use this line if react-i18next is configured

  return (
    // Re-applied the fix from the previous step to control overall bottom padding
    <Box sx={{ p: { xs: 2, sm: 4, md: 8 }, pb: 4, bgcolor: "#f7f7f7" }}>
      {/* Headings Section - Centered on mobile, left-aligned on larger screens */}
      <Box
        sx={{
          mb: 4,
          ml: { xs: 0, sm: 4 },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        <Typography
          variant="h4"
          fontWeight={700}
          sx={{
            mb: 0.5,
            color: "black",
            fontFamily: "Playfair Display, serif",
          }}
        >
          {t("common:zipangLanding:ourTeam:ourTeamheading")}
        </Typography>
        <Typography
          variant="h5"
          fontWeight={600}
          sx={{ color: "#D92B3C", fontFamily: "Playfair Display, serif" }}
        >
          {t("common:zipangLanding:ourTeam:ourteamSubHeading")}
        </Typography>
      </Box>

      {/* 3x3 Profile Grid Container - Centering is handled here */}
      <Grid
        container
        // Use spacing to prevent overlapping and create gutters
        spacing={4}
        // Increased maxWidth to 2000 as requested (preserved from original)
        sx={{
          width: "100%",
          maxWidth: 2000,
          margin: "0 auto", // This centers the grid horizontally
          // Removed justifyContent: "center" to align items to the left
        }}
      >
        {teamMembers.map((member) => (
          <TeamCard key={member.id} member={member} />
        ))}
      </Grid>
    </Box>
  );
};

export default OurTeamProfileGrid;
